/*
    use as service to resize images.

    it return observable.
    takes in size - image is supposed to be resized to.

    and return the image in Base64
*/
import { BehaviorSubject } from 'rxjs';

// create default canvas.
const canvas = document.createElement('canvas');

const previewCanvas = document.createElement('canvas');

// default image size.
let imageSettings = {
   width: 1150,
   height: 250,
};

const imageToUploadSubject = new BehaviorSubject('');
const imagePreviewSubject = new BehaviorSubject('');

// Returns a canvasDataURL with the resized param
const getCanvasDataURL = ({
   image,
   targetWidth,
   targetHeight,
   canvas,
}) => {
   const imageWidth = image.width;
   const imageHeight = image.height;

   let ratio = 1;
   if (imageWidth > imageHeight) {
      if (imageWidth > targetWidth) {
         ratio = targetWidth / imageWidth;
      }
   } else {
      if (imageHeight > targetHeight) {
         ratio = targetHeight / imageHeight;
      }
   }

   const canvasContext = canvas.getContext('2d');

   canvasContext.clearRect(0, 0, targetWidth, targetHeight);

   if (canvasContext.imageSmoothingQuality) {
      canvasContext.imageSmoothingQuality = 'high';
   }

   canvas.width = targetWidth;
   canvas.height = targetHeight;

   const correctedWidth = image.width * ratio;
   const correctedHeight = image.height * ratio;

   canvasContext.drawImage(image, 0, 0, image.width, image.height,
      (targetWidth - correctedWidth) / 2,
      (targetHeight - correctedHeight) / 2,
      correctedWidth, correctedHeight);

   return canvas.toDataURL();
};

// takes in file path of the image.
const resizeImage = (img, imageSize) => {
   let finalImageSize = Object.assign(
      imageSettings,
      imageSize,
   );

   let image = new Image();
   image.onload = function () {
      const canvasDataURL = getCanvasDataURL({
         image: image,
         targetWidth: finalImageSize.width,
         targetHeight: finalImageSize.height,
         canvas: canvas,
      });
      imageToUploadSubject.next(canvasDataURL);

      const previewDataURL = getCanvasDataURL({
         image,
         targetWidth: 128,
         targetHeight: 128,
         canvas: previewCanvas,
      });
      imagePreviewSubject.next(previewDataURL);
   };
   image.src = img;
};

const loadFileFromImage = (imgSrc, imageSize) => {
   // set image file reader.
   const imgReader = new FileReader();

   imgReader.onload = function (e) {
      resizeImage(e.target.result, imageSize);
   };

   imgReader.readAsDataURL(imgSrc);
};

export {
   loadFileFromImage,
   resizeImage,
   imageToUploadSubject,
   imagePreviewSubject,
};
